<div class="breadcrumbGlobal">
    <a [routerLink]="['/mydashboard']">
        <mat-icon>home</mat-icon>
    </a>
    <mat-icon>chevron_right</mat-icon>
    <a [routerLink]="['/vertical-solutions']">
        <span translate>COMMONS.VERTICAL_SOLUTIONS_SECTION</span>
    </a>
    <mat-icon>chevron_right</mat-icon>
    <a [routerLink]="['/vertical-solutions/vertical-solutions-management']">
        <span translate>COMMONS.VERTICAL_SOLUTIONS_MANAGEMENT</span>
    </a>
    <mat-icon>chevron_right</mat-icon>
    <span translate>COMMONS.VERTICAL_SOLUTIONS_INSERT_MODIFY</span>
</div>

<tb-header specificTitle="COMMONS.VERTICAL_SOLUTIONS_INSERT_MODIFY"> </tb-header>
<div class="contentGlobal">
    <form #mainDataForm="ngForm">
        <mat-card class="vertical-solution-card">
            <mat-card-header>
                <mat-card-subtitle translate>COMMONS.VERTICAL_SOLUTIONS_MASTER_DATA</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
                <div style="display: flex; flex-direction: column; justify-content: flex-start">
                    <mat-form-field appearance="outline">
                        <mat-label translate>COMMONS.SIGNATURE</mat-label>
                        <input
                            [disabled]="editMode"
                            matInput
                            required
                            [(ngModel)]="productDto.Signature"
                            name="Signature"
                            [formControl]="signatureControl"
                            [maxLength]="50"
                        />
                        <mat-hint>
                            <span class="mathintinputform" translate>COMMONS.INVALID_INPUT_MESSAGE_50_NOWHITESPACE</span>
                        </mat-hint>
                        <mat-error *ngIf="signatureControl.invalid">{{ getErrorSignatureMessage() }}</mat-error>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field appearance="outline">
                        <mat-label translate>COMMONS.DESCRIPTION</mat-label>
                        <input
                            [disabled]="editMode"
                            matInput
                            [(ngModel)]="productDto.Description"
                            [formControl]="descriptionControl"
                            name="Description"
                            [maxLength]="64"
                        />
                        <mat-hint>
                            <span class="mathintinputform" translate> COMMONS.INVALID_INPUT_MESSAGE_64 </span>
                        </mat-hint>
                        <mat-error *ngIf="descriptionControl.invalid">{{ getErrorDescriptionMessage() }}</mat-error>
                    </mat-form-field>
                </div>
                <div>
                    <mat-slide-toggle
                        (change)="onValueChange($event)"
                        [checked]="productDto.Active"
                        [(ngModel)]="productDto.Active"
                        name="SolutionActive"
                    >
                        <span translate>COMMONS.VERTICAL_SOLUTION_ACTIVE</span>
                    </mat-slide-toggle>
                </div>
            </mat-card-content>
        </mat-card>

        <mat-card class="vertical-solution-card" style="margin-top: 3rem">
            <mat-card-header>
                <mat-card-subtitle translate>COMMONS.VERTICAL_SOLUTIONS_ACTIVATION_SERVICE</mat-card-subtitle>
            </mat-card-header>
            <p style="font-size:small">{{ activationServiceIntro }}</p>
            <mat-card-content>
                <div style="margin-bottom: 2rem">{{ servicedataintroduction }}</div>
                <p translate>COMMONS.SELECT_ACTIVATION_TYPE</p>
                <div  [ngClass]="this.smallScreen ? 'horizontal-alignment' : 'vertical-alignment'" >
                  <div>
                    <mat-card
                        [ngClass]="
                            isNewActivation
                                ? 'vertical-solution-card-activation vertical-solution-card-activation-selected style-3 mat-elevation-z15'
                                : 'vertical-solution-card-activation style-3 mat-elevation-z15'
                        "
                        style="width: 45%; padding: 1.2rem"
                    >
                        <div style="display: flex; flex-direction: row; justify-content: flex-start">
                            <div>
                                <button mat-icon-button color="primary" (click)="onClickAttivationType(1)">
                                    <mat-icon *ngIf="isNewActivation">radio_button_checked</mat-icon>
                                    <mat-icon *ngIf="!isNewActivation">radio_button_unchecked</mat-icon>
                                </button>
                            </div>
                            <div>
                                <mat-card-title
                                    ><div style="padding: 0.4rem" translate>COMMONS.ACTIVATION_TYPE_API_REST</div></mat-card-title
                                >
                                <mat-card-content>
                                    <div style="display: flex; flex-direction: column">
                                        <div class="textGray400 text-uppercase" style="padding: 0.2rem; display: flex">
                                            <div><mat-icon>verified</mat-icon></div>
                                            <div style="margin-top: 0.2rem; margin-left: 0.2rem">
                                                <span translate>COMMONS.RECOMMENDED_CHOICE</span>
                                            </div>
                                        </div>

                                        <div style="margin-bottom: 1.5rem">{{ restactivationintroduction }}</div>

                                        <div
                                            [ngClass]="isNewActivation ? 'message-box-warning' : 'message-box-disabled'"
                                            style="display: flex; flex-direction: row; justify-content: space-between"
                                            *ngIf="!keyCreated"
                                        >
                                            <div>{{ newkeyintroduction }}</div>
                                            <div>
                                                <button
                                                    mat-flat-button
                                                    color="primary"
                                                    (click)="generateSolutionKey()"
                                                    [disabled]="!isNewActivation"
                                                >
                                                    <span translate>COMMONS.CREATE</span>
                                                </button>
                                            </div>
                                        </div>
                                        <div
                                            *ngIf="keyCreated"
                                            [ngClass]="isNewActivation ? 'message-box-info' : 'message-box-disabled'"
                                            style="display: flex; flex-direction: row; justify-content: space-between"
                                        >
                                            <div>{{ modifykeyintroduction }}</div>
                                            <div>
                                                <button
                                                    mat-flat-button
                                                    color="primary"
                                                    [disabled]="!isNewActivation"
                                                    (click)="generateSolutionKey()"
                                                >
                                                    <span translate>COMMONS.CREATE</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </mat-card-content>
                            </div>
                        </div>
                    </mat-card>
                  </div>
                  <div>
                    <mat-card
                        [ngClass]="
                            this.isOldActivation
                                ? 'vertical-solution-card-activation vertical-solution-card-activation-selected style-3 mat-elevation-z15'
                                : 'vertical-solution-card-activation style-3 mat-elevation-z15'
                        "
                        style="width: 45%; padding: 1.2rem"
                    >
                        <div style="display: flex; flex-direction: row; justify-content: flex-start">
                            <div>
                                <button mat-icon-button color="primary" (click)="onClickAttivationType(2)">
                                    <mat-icon *ngIf="isOldActivation"> radio_button_checked </mat-icon>
                                    <mat-icon *ngIf="!isOldActivation"> radio_button_unchecked </mat-icon>
                                </button>
                            </div>
                            <div>
                                <mat-card-title>
                                    <div style="padding: 0.4rem" translate>COMMONS.ACTIVATION_TYPE_WSE</div>
                                </mat-card-title>

                                <mat-card-content>
                                    <div class="textGray400 text-uppercase" style="padding: 0.2rem; display: flex">
                                        <div><mat-icon>report</mat-icon></div>
                                        <div style="margin-top: 0.2rem; margin-left: 0.2rem">
                                            <span translate>COMMONS.DEPRECATED_CHOICE</span>
                                        </div>
                                    </div>
                                    <div style="margin-top: 1.5rem">
                                        <div [innerHtml]="wseactivationintroduction"></div>
                                    </div>
                                </mat-card-content>
                            </div>
                        </div>
                    </mat-card>
                  </div>
                </div>
                <div style="margin-top: 2rem">
                    <mat-form-field appearance="outline">
                        <mat-label translate>COMMONS.URL_ACTIVATION_SERVICE</mat-label>
                        <input
                            [disabled]="webServiceUrlIsDisable()"
                            matInput
                            name="UrlWebService"
                            #wsUrl
                            [(ngModel)]="productDto.WebServiceURL"
                        />
                    </mat-form-field>
                </div>
                <div>
                    <mat-slide-toggle
                        (change)="onValueChangeWS($event)"
                        [disabled]="webServiceUrlIsDisable()"
                        [(ngModel)]="productDto.WebServiceUrlNotReliable"
                        name="webServiceActive"
                    >
                        <span translate>COMMONS.VERTICAL_SOLUTIONS_WEBSERVICE_ACTIVE</span>
                    </mat-slide-toggle>
                </div>
                <div *ngIf="showMessage">
                    <div class="message-box error" *ngIf="isError">
                        <span>{{ this.messageBoxMessage }}</span>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>

        <mat-card-actions>
            <button
                mat-flat-button
                color="primary"
                (click)="createorUpdateVerticalSolution()"
                [disabled]="isInvalid() || mainDataForm.invalid"
            >
                <span *ngIf="isNew" translate>COMMONS.VERTICAL_SOLUTIONS_CREATE_NEW_SOLUTION</span>
                <span *ngIf="!isNew" translate>COMMONS.VERTICAL_SOLUTIONS_MODIFY_SOLUTION</span>
            </button>
        </mat-card-actions>
    </form>
</div>
